import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-checkpoint-edit-conditions-description',
    template: `
        <mat-card class="fi-rounded-card fi-checkpoint-edit-tab-description-card">
            <mat-card-content>
                <div>
                    <mat-card-title class="checklist-card-title">{{
                        'checklist.checkpoint_answering_conditions' | fiAppText
                    }}</mat-card-title>
                    <p
                        class="checkpoint-card-text"
                        [innerHTML]="'checklist.checkpoint_answering_conditions_description' | fiAppText"
                    ></p>
                </div>
            </mat-card-content>
        </mat-card>
    `,
    styleUrls: ['./conditions-description.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checkpoint-edit-conditions-description' },
    standalone: false,
})
export class FiCheckpointEditConditionsDescriptionComponent {}
